
import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image, Font } from '@react-pdf/renderer';
import { Table, TableHeader, TableCell, TableBody, DataTableCell } from "@david.kucsai/react-pdf-table";
import premier_letter_head from "../img/premier_letterhead.jpeg";
import RobotoBold from "../assets/fonts/Roboto-Bold.ttf";
import RobotoRegular from "../assets/fonts/Roboto-Regular.ttf";
import RobotoLight from "../assets/fonts/Roboto-Light.ttf";
import { tr } from 'date-fns/locale';


// Register font
// Font.register(
// {
//   family: 'RobotoLight',
//   fonts: [
//     {
//       src: RobotoLight
//     }
//   ]
// }
// );

Font.register({
    family: "Roboto",
    fonts: [
        {
            src: RobotoLight,
            fontWeight: 300,
        },
        {
            src: RobotoRegular,
            fontWeight: 400,
        },
        {
            src: RobotoBold,
            fontWeight: 700,
        }

    ]
});

// Create styles
const styles = StyleSheet.create({

    page: {
        flexDirection: 'column',
        backgroundColor: '#ffffff',
        paddingTop: 30,
        paddingBottom: 50,
        paddingHorizontal: 25,
    },
    section: {
        margin: 10,
        padding: 10,
    },
    topSectionSingleRow:
    {
        flexDirection: "row",
        marginTop: 10
    },
    top_section_label: {
        fontSize: 14,
        fontFamily: "Roboto",
        fontWeight: 400,
        width: "25%"
    },
    top_section_value: {
        fontSize: 13,
        fontFamily: "Roboto",
        fontWeight: 300,
        width: "75%"
    },

    pageNumber: {
        position: 'absolute',
        fontSize: 12,
        bottom: 30,
        left: 0,
        right: 0,
        textAlign: 'center',
        color: 'grey',
    },


});

const DocumentWaitingForAccept = (props) => (


    <Document>

        <>
            {
                console.log("datafrom main parent Waiting for accept", props.dataFromParentPage?.table_row_values)
            }
        </>

        <Page size="A4" style={styles.page}>

            <View>

                <View>
                    <Image source={premier_letter_head} />
                </View>

                <View style={{ marginTop: 20, marginBottom: 20 }}>
                    <View style={styles.topSectionSingleRow}>
                        <Text style={styles.top_section_label}>Order No.</Text><Text style={styles.top_section_value}>{props.dataFromParentPage?.orderNo} </Text>
                    </View>
                    <View style={styles.topSectionSingleRow}>
                        <Text style={styles.top_section_label}>Date & Time</Text><Text style={styles.top_section_value}>{props.dataFromParentPage?.dateTime}</Text>
                    </View>
                    <View style={styles.topSectionSingleRow}>
                        <Text style={styles.top_section_label}>Reference</Text><Text style={styles.top_section_value}>{props.dataFromParentPage?.reference} </Text>
                    </View>
                    <View style={styles.topSectionSingleRow}>
                        <Text style={styles.top_section_label}>Remarks</Text><Text style={styles.top_section_value}>{props.dataFromParentPage?.remarks} </Text>
                    </View>

                </View>

                <Table
                    data={

                        props.dataFromParentPage?.table_row_values
                    }
                >
                    <TableHeader
                    >
                        <TableCell style={{ padding: 4 }} weighting={0.1}>
                            Sl.No.
                        </TableCell >
                        <TableCell style={{ padding: 4 }} weighting={0.2}>
                            Part Number
                        </TableCell>
                        <TableCell style={{ padding: 4 }} weighting={0.6}>
                            Description
                        </TableCell>
                        <TableCell style={{ padding: 4 }} weighting={0.1}>
                            Qty
                        </TableCell>
                    </TableHeader>
                    <TableBody >
                        <DataTableCell style={{ padding: 4 }} weighting={0.1} getContent={(r) => r.sl_no} />
                        <DataTableCell style={{ padding: 4 }} weighting={0.2} getContent={(r) => r.code} />
                        <DataTableCell style={{ padding: 4 }} weighting={0.6} getContent={(r) => r.description} />
                        <DataTableCell style={{ padding: 4 }} weighting={0.1} getContent={(r) => r.req_ty} />
                    </TableBody>
                </Table>

            </View>

            <Text style={styles.pageNumber} render={({ pageNumber, totalPages }) => (
                `${pageNumber} / ${totalPages}`
            )} fixed />

        </Page>
    </Document>
);

export default DocumentWaitingForAccept;